import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.element.style.display = "block"
    this.element.classList.add("show")

    document.body.classList.add("modal-open")
    document.body.style.overflow = "hidden"

    const backdrop = document.querySelector(".modal-backdrop")
    if (backdrop) {
      backdrop.style.display = "block"
      backdrop.classList.add("show")
    }
  }

  disconnect() {
    // 🔥 DAS IST DER KEY FIX
    document.body.classList.remove("modal-open")
    document.body.style.overflow = "auto"
    document.body.style.paddingRight = "0"

    document.querySelectorAll(".modal-backdrop").forEach(el => el.remove())
  }

  close(e) {
    if (e) e.preventDefault()
    this.element.remove()
  }
}